// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32EN7","label":"styles_label__12WKS"};